var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("The page you came is not found")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home page")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }